import { Component } from '@angular/core';

@Component({
  selector: 'mc-routing-slot',
  template: `<router-outlet></router-outlet>`
})
export class RoutingSlotComponent {
}
